import React from 'react';
import { GlobalOutlined, MoonOutlined, SafetyCertificateOutlined, SunOutlined } from '@ant-design/icons';
import { LANGUAGE_OPTIONS } from '../i18n';
import './Login.css';

function AuthShell({
  variant = 'admin',
  themeMode = 'light',
  onToggleThemeMode,
  language = 'zh-CN',
  onLanguageChange,
  languageOptions = LANGUAGE_OPTIONS,
  lightModeLabel = '浅色模式',
  darkModeLabel = '暗夜模式',
  languageLabel = '语言',
  brandMark = '末',
  brandName = '旭日之战',
  brandSubtitle = 'Unified Operations',
  eyebrow,
  title,
  description,
  stats = [],
  featureTitle = '今日工作区',
  features = [],
  panelEyebrow,
  panelTitle,
  panelDescription,
  panelNotice,
  children,
  footer
}) {
  const isDarkMode = themeMode === 'dark';

  return (
    <main className={`auth-page auth-page-${variant}`}>
      <div className="auth-top-actions">
        <label className="auth-language-control">
          <GlobalOutlined aria-hidden="true" />
          <span className="sr-only">{languageLabel}</span>
          <select value={language} onChange={(event) => onLanguageChange?.(event.target.value)} aria-label={languageLabel}>
            {languageOptions.map((option) => (
              <option value={option.value} key={option.value}>{option.label}</option>
            ))}
          </select>
        </label>
        <button
          className="auth-theme-toggle"
          type="button"
          onClick={onToggleThemeMode}
          aria-label={isDarkMode ? lightModeLabel : darkModeLabel}
        >
          {isDarkMode ? <SunOutlined /> : <MoonOutlined />}
          <span>{isDarkMode ? lightModeLabel : darkModeLabel}</span>
        </button>
      </div>

      <section className="auth-shell" aria-label={panelTitle}>
        <div className="auth-hero">
          <div className="auth-brand">
            <span className="auth-brand-mark" aria-hidden="true">{brandMark}</span>
            <span className="auth-brand-text">
              <strong>{brandName}</strong>
              <small>{brandSubtitle}</small>
            </span>
          </div>

          <div className="auth-hero-copy">
            <span className="auth-eyebrow">{eyebrow}</span>
            <h1>{title}</h1>
            <p>{description}</p>
          </div>

          {stats.length > 0 && (
            <div className="auth-stat-grid">
              {stats.map((item) => (
                <div className="auth-stat" key={item.label}>
                  <span>{item.label}</span>
                  <strong>{item.value}</strong>
                </div>
              ))}
            </div>
          )}

          {features.length > 0 && (
            <div className="auth-feature-board">
              <div className="auth-feature-board-head">
                <SafetyCertificateOutlined />
                <span>{featureTitle}</span>
              </div>
              <div className="auth-feature-list">
                {features.map((item) => (
                  <div className="auth-feature" key={item.title}>
                    <span className="auth-feature-icon">{item.icon}</span>
                    <span>
                      <strong>{item.title}</strong>
                      <small>{item.text}</small>
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="auth-panel">
          <div className="auth-panel-card">
            <div className="auth-panel-head">
              <span className="auth-panel-eyebrow">{panelEyebrow}</span>
              <h2>{panelTitle}</h2>
              <p>{panelDescription}</p>
            </div>
            {panelNotice && <div className="auth-panel-notice">{panelNotice}</div>}
            {children}
            {footer && <div className="auth-panel-footer">{footer}</div>}
          </div>
        </div>
      </section>
    </main>
  );
}

export default AuthShell;
